import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ReplayControl } from "../components/ReplayControl";
export const MIN_REPLAY_SPEED = 0.25;
export const MAX_REPLAY_SPEED = 4;
const defaultState = {
    replayMode: false,
    status: null,
    speedMultiplier: 1,
    replayTime: 0,
};
export const ReplayContext = React.createContext(defaultState);
export const ReplayContextProvider = ({ children }) => {
    const state = defaultState;
    return (_jsxs(ReplayContext.Provider, { value: state, children: [state.replayMode && _jsx(ReplayControl, { zIndex: 3 }), children] }));
};
export const useReplayContext = () => {
    return React.useContext(ReplayContext);
};
//# sourceMappingURL=replayContext.js.map